import './NotFoundError.less';
import React from 'react';
import ErrorTemplate from "../../templates/error/ErrorTemplate";
import config from "../../../../../config.json";
import __ from "../../i18n";


export default function NotFoundError({}) {

    return <div className="not-found-error">
        <ErrorTemplate
            imageSrc={config.img_error_not_found}
            title={__('Content not found')}
            description={__('not_found_error_description')}
        />
    </div>;
}
